export default __webpack_public_path__ + "static/media/Ostali 3.1f75f744.jpg";